import { Sections, usePage } from "../../hooks/usePage";
import HeroSection from "../../components/home/HeroSection";
import { AboutEvent, Benefits, Stats } from "../../components/home/HomeSections";
import { Loading } from "../../components/site/Blocks";
import { SponsorBanners } from "../../components/site/SponsorShowcase";

const RENDER = { hero: HeroSection, benefits: Benefits, about: AboutEvent, stats: Stats };

export default function Home() {
  const { page, loading } = usePage("home");
  if (loading) return <Loading />;
  return <div data-testid="home-page"><Sections page={page} render={RENDER} /><SponsorBanners /></div>;
}
